/**
 * OrbDocReferenceBehaviorsAROrbDocReferenceBehaviorsARPage
 *
 * Page component for OrbDocReferenceBehaviorsAROrbDocReferenceBehaviorsARPage
 * Path: /ar/docs/reference/behaviors
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocReferenceBehaviorsARDocScreenView as __OrbDocReferenceBehaviorsARDocScreenView } from '@/components/traits/OrbDocReferenceBehaviorsARDocScreenView';
import { OrbDocReferenceBehaviorsARDocAnalyticsView as __OrbDocReferenceBehaviorsARDocAnalyticsView } from '@/components/traits/OrbDocReferenceBehaviorsARDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocReferenceBehaviorsAROrbDocReferenceBehaviorsARPageProps {
  // Add any page-level props here
}

export function OrbDocReferenceBehaviorsAROrbDocReferenceBehaviorsARPage(_props: OrbDocReferenceBehaviorsAROrbDocReferenceBehaviorsARPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"السلوكيات القياسية","description":"مكتبة @almadar/std العامة: كل سلوك يستطيع البرنامج استيراده بـ `uses`، مرتّبًا حسب الموضوع.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/reference/behaviors"},{"locale":"ar","path":"/ar/docs/reference/behaviors"},{"locale":"sl","path":"/sl/docs/reference/behaviors"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocReferenceBehaviorsARDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocReferenceBehaviorsARDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocReferenceBehaviorsAROrbDocReferenceBehaviorsARPage;
